import React from "react";
import CodeMirror from '@uiw/react-codemirror';
import { autocompletion } from "@codemirror/autocomplete"
import { githubLight } from '@uiw/codemirror-theme-github';
import { languages } from '@codemirror/language-data';
import { python } from '@codemirror/lang-python';
import { Box } from "@chakra-ui/react";

function Editor({ onOpen, value, onChange, myCompletions }) {
    return (
        <Box borderColor='black' borderWidth='1.2px'><CodeMirror
            onClick={onOpen ? onOpen : () => { }}
            value={value}
            height="40vh"
            fontSize="40px"
            extensions={[
                autocompletion({ override: [myCompletions] }), python({ base: python, codeLanguages: languages })
            ]
            }
            options={{
                tabSize: 2,
                lint: true,
                lineNumbers: true,
                lineWrapping: true,
                spellcheck: true,
                autoCloseTags: true,
                autoCloseBrackets: true,
                matchTags: true,
                matchBrackets: true
            }}
            theme={githubLight}
            overflow="auto"
            onChange={onChange}
        /></Box>
    )
}

export default Editor;
